
    import '/mnt/docs/index.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/index.md?type=demo')
};